// extracted by mini-css-extract-plugin
export default {"Camera":"Camera_Camera__ujA5h","Camera__label":"Camera_Camera__label__kfiQH","Camera__row":"Camera_Camera__row__yUIrE"};